var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.551,
    height: 49.5,
    viewBox: "0 0 63.551 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_3_User",
    "data-name": "Iconly/Light/3 User",
    transform: "translate(0.776 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3_User",
    "data-name": "3 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M0,18.022A8.9,8.9,0,0,0,8.773,9.011,8.9,8.9,0,0,0,0,0",
    transform: "translate(48.087 2.925)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,0A27.81,27.81,0,0,1,4.3.641c1.967.4,4.334,1.224,5.176,3.038a4.4,4.4,0,0,1,0,3.678C8.637,9.17,6.268,10,4.3,10.412",
    transform: "translate(52.12 30.74)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M8.773,18.022A8.9,8.9,0,0,1,0,9.011,8.9,8.9,0,0,1,8.773,0",
    transform: "translate(5.14 2.925)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M9.879,0a27.81,27.81,0,0,0-4.3.641c-1.967.4-4.334,1.224-5.174,3.038a4.376,4.376,0,0,0,0,3.678C1.242,9.17,3.611,10,5.579,10.412",
    transform: "translate(0 30.74)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_9",
    "data-name": "Stroke 9",
    d: "M18.2,0c9.815,0,18.2,1.526,18.2,7.633s-8.33,7.687-18.2,7.687C8.382,15.32,0,13.794,0,7.687S8.33,0,18.2,0Z",
    transform: "translate(12.785 32.68)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_11",
    "data-name": "Stroke 11",
    d: "M11.663,23.969A11.786,11.786,0,0,1,0,11.983,11.786,11.786,0,0,1,11.663,0,11.786,11.786,0,0,1,23.327,11.983,11.786,11.786,0,0,1,11.663,23.969Z",
    transform: "translate(19.322)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrder);
export default __webpack_public_path__ + "static/media/pending_order.5747bc4e534131e436e0e69efaa21704.svg";
export { ForwardRef as ReactComponent };